import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ProductSearchDialogComponent } from '@app/product/product-search-dialog/product-search-dialog.component';
import { AppComponentBase } from '@shared/app-component-base';
import { ProductDto } from '@shared/service-proxies/service-proxies';

@Component({
  selector: 'app-select-product',
  templateUrl: './select-product.component.html',
  styleUrls: ['./select-product.component.css']
})

export class SelectProductComponent extends AppComponentBase implements OnInit {

  @Input()
  text: string = this.l('SelectProduct');

  private _selection: ProductDto = null;
  get selection(): ProductDto {
    return this._selection;
  }
  @Input()
  set selection(value: ProductDto) {
    if (this._selection === value) {
      return;
    }
    this._selection = value;
    this.selectionChange.emit(this._selection);
  }
  @Output() selectionChange = new EventEmitter<ProductDto>();

  constructor(injector: Injector,
    private _dialog: MatDialog) {
    super(injector);
  }

  ngOnInit(): void {
  }

  onSearch() {
    let clientSearchDialog = this._dialog.open(ProductSearchDialogComponent);
    clientSearchDialog.componentInstance.selectedItem.subscribe(returnData => {
      this.selection = returnData;
    });
  }

  onClear() {
    this.selection = null;
  }

  // onSelectionChnaged() {
  //   this.selectionChange.emit(this.selection);
  // }
}

